import { colors } from '@apollo/brand';
import * as monacoEditor from 'monaco-editor';

const { bg, code, text, border } = colors.tokens;

export const STUDIO_THEME_LIGHT = 'studio-light';
export const studioThemeLight: monacoEditor.editor.IStandaloneThemeData = {
  base: 'vs',
  inherit: true,
  colors: {
    // full index available at https://code.visualstudio.com/api/references/theme-color
    'editorLineNumber.foreground': text.secondary.base,
    'editorLineNumber.activeForeground': text.primary.base,
    'editorIndentGuide.background': border.primary.base,
    'editorIndentGuide.activeBackground': border.hover.base,
    // minimap
    'minimap.background': bg.secondary.base,
    // suggestion popover
    'editorWidget.background': bg.primary.base,
    'editorWidget.foreground': text.primary.base,
    'editorWidget.border': border.primary.base,
    'editorWidget.resizeBorder': border.primary.base,
    'editorSuggestWidget.selectedBackground': bg.info.base,
    'editorSuggestWidget.selectedForeground': text.info.base,
    'editorSuggestWidget.border': border.primary.base,
    'editorSuggestWidget.highlightForeground': code.b.base,
    'editorSuggestWidget.focusHighlightForeground': code.b.base,
    // context menu
    'menu.background': bg.primary.base,
    'menu.foreground': text.primary.base,
    'menu.selectionBackground': bg.secondary.base,
    'menu.selectionForeground': text.primary.base,
    'menu.separatorBackground': border.primary.base,
    'diffEditor.insertedTextBackground': bg.success.base,
    'diffEditor.removedTextBackground': bg.error.base,
    'diffEditor.border': border.primary.base,
    'diffEditor.diagonalFill': bg.secondary.base,
    // peek view (goto definition/reference/etc.)
    'peekView.border': border.primary.base,
    'peekViewEditor.background': bg.primary.base,
    'peekViewEditor.matchHighlightBackground': bg.highlight.base,
    'peekViewTitle.background': bg.secondary.base,
    'peekViewResult.background': bg.secondary.base,
    'peekViewResult.lineForeground': text.secondary.base,
    'peekViewResult.selectionBackground': bg.info.base,
    'peekViewResult.selectionForeground': text.primary.base,
    'peekViewResult.matchHighlightBackground': bg.highlight.base,
  },
  // rules have specificity that's kind of similar to css
  // more matching segments results in higher specificity
  rules: [
    {
      token: 'punctuation',
      foreground: code.a.base.replace(/^#/, ''),
    },

    // graphql colors
    { token: 'comment', foreground: code.f.base.replace(/^#/, '') },

    // operation type (this includes keyword.query, keyword.mutation, keyword.subscription)
    { token: 'keyword', foreground: code.b.base.replace(/^#/, '') },

    // operation name
    { token: 'def', foreground: code.a.base.replace(/^#/, '') },

    // argument name declaration
    { token: 'variable', foreground: code.g.base.replace(/^#/, '') },

    // argument type, fragment parent type
    {
      token: 'atom.namedtype',
      foreground: code.c.base.replace(/^#/, ''),
    },

    // argument name
    {
      token: 'attribute.argument',
      foreground: code.d.base.replace(/^#/, ''),
    },

    // field name
    { token: 'property', foreground: code.d.base.replace(/^#/, '') },

    // directive name
    {
      token: 'meta.directive',
      foreground: code.e.base.replace(/^#/, ''),
    },
    {
      token: 'meta.directivedef',
      foreground: code.e.base.replace(/^#/, ''),
    },

    // literal argument values
    {
      token: 'builtin.booleanvalue',
      foreground: code.g.base.replace(/^#/, ''),
    },
    { token: 'string', foreground: code.g.base.replace(/^#/, '') },
    { token: 'number', foreground: code.g.base.replace(/^#/, '') },

    // JSON colors
    {
      token: 'string.key.json',
      foreground: code.d.base.replace(/^#/, ''),
    },
    {
      token: 'string.value.json',
      foreground: code.g.base.replace(/^#/, ''),
    },
    { token: 'keyword.json', foreground: code.g.base.replace(/^#/, '') },
    { token: 'number.json', foreground: code.g.base.replace(/^#/, '') },
    {
      token: 'delimiter.bracket.json',
      foreground: code.a.base.replace(/^#/, ''),
    },
    {
      token: 'delimiter.colon.json',
      foreground: code.a.base.replace(/^#/, ''),
    },
    {
      token: 'delimiter.comma.json',
      foreground: code.a.base.replace(/^#/, ''),
    },
  ],
};
